import { BottomSheet } from '@s4l/ds'
import { HeaderWithSlotsProps } from 'client/components/HeaderWithSlots'
import React from 'react'
import { useIntl } from 'react-intl'
import OmniSearch from 'src/comps/OmniSearch'
import { useDevice } from 'src/hooks/useDevice'
import { useSearch } from 'src/hooks/useSearch'
import { BreakpointSizes } from 'src/types/device'
import { SearchMode, SearchUrl } from 'src/types/search'
import MinimalHeader from '../MinimalHeader'
import styles from './styles.module.css'

interface IOmniSearchSmall {
  searchUrl: SearchUrl
  preventNavigation?: boolean
  onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void
}
const OmniSearchSmall = ({ searchUrl, preventNavigation, onClick }: IOmniSearchSmall) => {
  const intl = useIntl()
  return (
    <BottomSheet snapPoints={[]}>
      <BottomSheet.Trigger className={styles.omnisearchSmall} data-testid="omnisearch-btn">
        <OmniSearch
          mode={SearchMode.Readonly}
          searchUrl={searchUrl}
          preventNavigation={preventNavigation}
        />
      </BottomSheet.Trigger>

      <BottomSheet.Content title={intl.formatMessage({ id: 'modify.search' })}>
        <OmniSearch
          mode={SearchMode.Full}
          searchUrl={searchUrl}
          preventNavigation={preventNavigation}
          onClick={onClick}
        />
      </BottomSheet.Content>
    </BottomSheet>
  )
}

type Props = Partial<HeaderWithSlotsProps> & {
  pageId: string
  preventNavigation?: boolean
  searchUrl?: SearchUrl
}

function OmniSearchHeader(props: Props) {
  const { searchUrl: newSearchUrl } = useSearch()

  const { bottom, pageId, fixed, preventNavigation, searchUrl = newSearchUrl } = props
  const { activeBreakpoint } = useDevice()

  let render = <OmniSearchSmall searchUrl={searchUrl} preventNavigation={preventNavigation} />

  if (activeBreakpoint >= BreakpointSizes.L) {
    render = (
      <div className={styles.omnisearchLarge}>
        <OmniSearch
          searchUrl={searchUrl}
          mode={SearchMode.Borderless}
          preventNavigation={preventNavigation}
          smallBtn
        />
      </div>
    )
  }

  return <MinimalHeader center={render} bottom={bottom} pageId={pageId} fixed={fixed} />
}

export default OmniSearchHeader
